import { css } from "styled-components";
import "../../designTokens/variables.css";

export const primaryButtonHover = css`
  background: var(--color-primary-500);
  border: 1px solid var(--color-primary-500);
  box-shadow: var(--elevation-2);
`;

export const primaryButtonActive = css`
  background: var(--color-secondary-800);
  border: 1px solid var(--color-secondary-800);
  box-shadow: var(--elevation-0);
`;
